import { RchAnalyticsService } from 'src/app/services/rch-analytics.service';
import {NgModule, isDevMode} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {CDKCoreModule} from "@rogers/cdk/core";
import {TranslateLoader, TranslateModule} from "@ngx-translate/core";
import {LoginComponent} from './components/login/login.component';
import {ActivationComponent} from './components/activation/activation.component';
import {AccountSelectionComponent} from './components/account-selection/account-selection.component';
import {ButtonComponent} from "@rogers/cdk/button";
import {FormModule} from "@rogers/cdk/form";
import {PopoverModule} from "@rogers/cdk/popover";
import {IconComponent} from "@rogers/cdk/icon";
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from "@angular/common/http";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {LanguageToggleComponent} from './components/language-toggle/language-toggle.component';
import {APP_BASE_HREF, CommonModule, NgOptimizedImage} from "@angular/common";
import {HeaderComponent} from './components/header/header.component';
import {FooterComponent} from './components/footer/footer.component';
import {LinkComponent} from "@rogers/cdk/link";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {
  CompatibleDevicesModalComponent
} from './components/compatible-devices-modal/compatible-devices-modal.component';
import {ModalModule} from "@rogers/cdk/modal";
import {ProgressSpinnerComponent} from '@rogers/cdk/progress-spinner';
import {RouteConstants} from "./constants/route-constants";
import { CookieService } from 'ngx-cookie-service';
import {
  AnalyticsService, ApplicationName,
  PendingPayloadsService,
  SiteName
} from '@rogers/analytics';
import { AnalyticsServiceWrapper, analyticsFactoryService } from './services/analytics-factory.service';
import { AnalyticsPayloadService } from './services/analytics-payload.service';
import { AnalyticsConstants } from './constants/analytics-constants';
import { BrandSelectionPageComponent } from './components/brand-selection-page/brand-selection-page.component';

export function HttpLoaderFactory(http: HttpClient) {
  const routeConst = RouteConstants;
  const prefix = isDevMode() ? routeConst.baseLangPath : routeConst.baseUrl+routeConst.baseLangPath;
  return new TranslateHttpLoader(http, prefix);
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ActivationComponent,
    AccountSelectionComponent,
    LanguageToggleComponent,
    HeaderComponent,
    FooterComponent,
    CompatibleDevicesModalComponent,
    BrandSelectionPageComponent
  ],
  imports: [
    CDKCoreModule.forRoot({
      brand: "rogers"
    }),
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    TranslateModule.forRoot(),
    ButtonComponent,
    FormModule,
    PopoverModule,
    IconComponent,
    HttpClientModule,
    NgOptimizedImage,
    LinkComponent,
    FormsModule,
    ReactiveFormsModule,
    ModalModule,
    ProgressSpinnerComponent,
    CommonModule
  ],
  providers: [
    {
      provide: APP_BASE_HREF,
      useValue: "/ignite-your-tv"
    },
    {
      provide: TranslateLoader,
      useFactory: HttpLoaderFactory,
      deps: [HttpClient]
    },
    {
      provide: SiteName,
      useValue: AnalyticsConstants.siteName
    },
    {
      provide: ApplicationName,
      useValue: AnalyticsConstants.applicationName
    },
    {
      provide: AnalyticsService,
      useFactory: analyticsFactoryService,
      deps: [
        AnalyticsPayloadService,
        PendingPayloadsService,
        SiteName,
        ApplicationName
      ]
    },
    {
      provide: HTTP_INTERCEPTORS,
      useFactory: AnalyticsServiceWrapper,
      deps: [AnalyticsService],
      multi: true
    },
    CookieService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { 
  constructor( private rchAnalyticsService: RchAnalyticsService){}
}
